// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"37a63566","170":"e7083e9a","787":"cda612ba"}[chunkId] + ".chunk.js";
};